<template>
  <div class="content">
    <div class="top">
      <div class="header">
        <img alt="logo" class="logo" src="../../assets/logo.jpeg" />
        <span class="title">CloudCat</span>
      </div>
      <div class="desc"></div>
    </div>

    <el-card class="login">
      <el-alert
        title="登陆注意事项"
        description="登陆的时候使用的用户名是邮箱的前缀，不要直接使用邮箱作为用户名登陆；git地址为https://dev.nenly.cn"
        type="success"
      />
      <el-form ref="form" :model="form" :rules="rules" style="margin: 15px;">
        <el-form-item prop="email">
          <el-input v-model="form.email" type="email" placeholder="请输入邮箱地址">
            <i slot="prefix" class="el-icon-message"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="passwordconfirm">
          <el-input v-model="form.passwordconfirm" type="password" placeholder="请再次输入密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="nickName">
          <el-input v-model="form.nickName" placeholder="请输入昵称">
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.phone" placeholder="请输入电话号" type="number">
            <i slot="prefix" class="el-icon-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.im" placeholder="请输入相关IM联系方式">
            <i slot="prefix" class="el-icon-notebook-1"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="logging"
            style="width: 100%;margin-top: 24px"
            size="large"
            type="primary"
            @click="register('form')"
          >注册</el-button>
        </el-form-item>已有账户
        <a href="#/login">现在登陆!</a>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("邮箱地址不能为空"));
      } else {
        setTimeout(() => {
          var pattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
          if (!pattern.test(value)) {
            callback(new Error("请输入正确的邮箱地址"));
          } else {
            callback();
          }
        }, 500);
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.passwordconfirm !== "") {
          this.$refs.form.validateField("passwordconfirm");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      logging: false,
      form: {
        email: "",
        nickName: "",
        password: "",
        passwordconfirm: "",
        phone: "",
        im: "",
      },
      rules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "change" }],
        passwordconfirm: [{ validator: validatePass2, trigger: "change" }],
        nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
      },
    };
  },
  methods: {
    register(formName) {
      const _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.$axios
            .post(_this.config.path + "/auth/register", _this.form)
            .then(function (response) {
              if (response.data.success === true) {
                _this.$message({
                  showClose: true,
                  message: "注册成功，去登陆吧",
                  type: "success",
                });
                setTimeout(function () {
                  location.href = "#/login";
                }, 2000);
              } else {
                console.log(response.data);
                _this.$message({
                  showClose: true,
                  message: "注册失败：" + response.data.message,
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              _this.$message({
                showClose: true,
                message: "注册失败：" + error.toString(),
                type: "error",
              });
            });
        } else {
          _this.$message({
            showClose: true,
            message: "注册失败，请填写必要的信息",
            type: "error",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style>
.content {
  padding: 32px 0;
  flex: 1;

  @media (min-width: 768px) {
    padding: 112px 0 24px;
  }
}

.top {
  text-align: center;
}

.header {
  height: 44px;
  line-height: 44px;
}

.logo {
  height: 44px;
  vertical-align: top;
  margin-right: 16px;
}

.title {
  font-size: 33px;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: 600;
  position: relative;
  top: 2px;
  margin-bottom: 16px;
}

.login {
  width: 368px;
  margin: 0 auto;

  @media screen and (max-width: 576px) {
    width: 95%;
  }

  @media screen and (max-width: 320px) {
    .captcha-button {
      font-size: 14px;
    }
  }
}

.icon {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.2);
  margin-left: 16px;
  vertical-align: middle;
  cursor: pointer;
  transition: color 0.3s;
}

.desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
  margin-bottom: 40px;
}

&:hover {
  color: #1890ff;
}
</style>